import overview from '@/views/webpc/MemberStatistics/overviewApp/overview'

// 定义路由路径数列表
export default [{
  path: '/overview',
  icon: 'el-icon-s-data',
  name: '统计概览',
  component: overview
}]



// WEBPACK FOOTER //
// ./src/views/webpc/MemberStatistics/overviewApp/routers/index.js